// React
import React from 'react';
// Api Services
import ApiServices from 'services/ApiServices';
// componentes
import Modal from 'components/CustomDialog';
import { Container, Grid} from '@material-ui/core';
import {useStyles} from './style';
import { CheckCircleOutline, ErrorOutline, Info } from '@material-ui/icons';

const TotalDeRangosDisponibles= (props)=> {
        const classes = useStyles();
        const rangos = [
            {title: 'Rango Inicial', value : props.rangoNoBoletas?.rangoInicial},
            {title: 'Rango Final', value: props.rangoNoBoletas?.rangoFinal},
            {title: 'Último Registro', value: props.rangoNoBoletas?.ultimoRegistro},
            {title: 'Boletas Faltantes', value: props.rangoNoBoletas?.boletasFaltantes},
          ]        
        return (
            <Modal 
                open={props.open}
                maxWidth={props.maxWidth}
                fullWidth={props.fullWidth}
                closeModal={props.closeModal}
                iconToolbar={props.iconToolbar}
                titleToolbar={props.titleToolbar}
            >
                <Container className={classes.colorComponente}>      
                    {
                        rangos.map((text, index) => (
                            <Grid className={classes.gridContainer} container direction="row" justifyContent="center" alignItems="center">
                                <Grid className={classes.header} item xs={12}></Grid>
                                <Grid className={classes.gridItemFirst} item xs={6}> <strong>{text.title}</strong></Grid>
                                <Grid className={classes.gridItemSecond} item xs={6}> <strong>{text.value}</strong> </Grid>
                            </Grid>      
                        ))
                    }
                    <Grid className={classes.gridContainer} container direction="row" justifyContent="center" alignItems="center">
                        <Grid className={classes.header} item xs={12}></Grid>
                        <Grid className={classes.gridItemFirst} item xs={6}> <strong>{'Estado'}</strong></Grid>
                        {
                            (props.rangoNoBoletas?.boletasFaltantes >=300) ? (
                                <Grid className={classes.gridItemSecond} style={{color: 'white', backgroundColor: '#157f15'}} item xs={6}> <CheckCircleOutline style={{fontSize: "25px"}}/> </Grid>
                            ) : (props.rangoNoBoletas?.boletasFaltantes >=200 && props.rangoNoBoletas?.boletasFaltantes<300) ? (
                                <Grid className={classes.gridItemSecond} style={{color: 'white', backgroundColor: '#e79000'}} item xs={6}> <ErrorOutline style={{fontSize: "25px"}}/> </Grid>
                            ) : (props.rangoNoBoletas?.boletasFaltantes<200) ? (
                                <Grid className={classes.gridItemSecond} style={{color: 'white', backgroundColor: '#CB1C00'}} item xs={6}> <Info style={{fontSize: "25px"}}/> </Grid>
                            ) : ''
                        }
                    </Grid><br /><br />
                </Container>
            </Modal>
        )
}

export default TotalDeRangosDisponibles;